import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Reemplaza con tu ID de medición (G-XXXXXXXXXX)
const TRACKING_ID = "G-VEZF6PNYRD"; 

// Inicializamos GA una sola vez fuera del componente
ReactGA.initialize(TRACKING_ID);

const AnalyticsTracker = () => {
    const location = useLocation();

     useEffect(() => {
        // TRUCO: Solo enviar datos si NO estamos en localhost
        if (window.location.hostname !== "localhost") {
            ReactGA.send({ 
                hitType: "pageview", 
                page: location.pathname + location.search 
            });
        }
    }, [location]);

    return null; // Este componente no renderiza nada visual
};

export default AnalyticsTracker;